import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-res-sales-onhold',
    templateUrl: './res-sales-onhold.component.html',
    styleUrls: ['./res-sales-onhold.component.css'],
    standalone: false
})
export class ResSalesOnholdComponent implements OnInit {

	@Input() holdReservations: any = [];
	@Input() holdReservationsCount: any = 0;
	@Input() groupDefaultExpanded: any = 0;

	constructor(
		public messageService: MessageService,
		public reportService: ReportService,
		private constantService: ConstantService,) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	columnDefs: ColDef[] = [
		// { headerName: 'Sold By', field: 'soldBy', },
		// { headerName: 'Hold Nights', field: 'numNightsTTL', aggFunc: 'sum'},
		// { headerName: 'Property', field: 'propertyCode'},
		// { headerName: 'Checkin', field: 'checkInDate', cellRenderer: this.fullDateCellRendererUSD,},
		// { headerName: 'Revenue', field: 'revRoomRateNetTTL', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },

		// { headerName: 'Sale Date', field: 'saleDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Location', field: 'locationId', sortable: true, sort:'asc', cellRenderer: params => this.getLocationName(params) },
		{ headerName: 'Development', field: 'developmentName', sortable: true, sort:'asc' },
		{ headerName: 'Property Code', field: 'propertyCode', sortable: true, sort:'asc'},
		// { headerName: 'Night Rate', field: 'revRoomRateNetPNT', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'Hold Nights', field: 'numNtsHoldTTL', aggFunc: 'sum' },
		{ headerName: 'Hold Date', field: 'holdDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Hold Expired', field: 'holdExpiredDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Revanue', field: 'revRoomRateNetTTL', cellRenderer: this.currencyCellRendererUSD, aggFunc: 'sum' },
		{ headerName: 'CheckIn', field: 'checkInDate', aggFunc: 'showArrivalDate' ,cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'CheckOut', field: 'checkOutDate', cellRenderer: this.fullDateCellRendererUSD, },
		{ headerName: 'Guest', field: 'guestLastName', cellRenderer: params => this.getReservationLink(params)   },
		{ headerName: 'Reservation Type', field: 'resStatus', cellRenderer: params => this.getReservationType(params)},
    	{ headerName: 'Agent', field: 'soldBy', },
	];


	gridOptions: GridOptions = {
		rowData: this.holdReservations,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,
	}

	// forms
	formLoading = false;

	// to hold the current search
	currentSearchForm: any;

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}

	ngOnInit(): void {

		// ag-grid
		this.gridOptions.rowData = this.holdReservations;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Footer
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;
	}

	ngAfterViewInit(): void {
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

	fullDateCellRendererUSD(params: any) {
		if (params.data && params.value) {
			return moment(params.value).format('MM/DD/YY')
		}
	}

	getReservationLink (params: any) {
		if(params.value)
		{
			let url = "https://admin.kbmhawaii.com/reservations-edit/"+params?.data?.reservationId;
			return '<a href='+url+' target="_blank">'+params.value+'</a>'
		}
	};

	getReservationType (params: any) {
		if (params.value) {
			if (params.value == "OP") {
				return "Guest"
			} else if (params.value == "OO") {
				return "Owner"
			} else if (params.value == "OG") {
				return "Owner Guest"
			} else if (params.value == "NA") {
				return "Maintenance"
			}
		}
	};

	getLocationName (params: any) {
		if (params.value) {
			return this.constantService.locations.find(function(item) { 
				return item.locationId == params.value 
			})?.name;
		}
	};

	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params.value);
	}
}
